import { render, staticRenderFns } from "./Hotspot.vue?vue&type=template&id=b90be19c&scoped=true"
import script from "./Hotspot.vue?vue&type=script&lang=js"
export * from "./Hotspot.vue?vue&type=script&lang=js"
import style0 from "./Hotspot.vue?vue&type=style&index=0&id=b90be19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90be19c",
  null
  
)

export default component.exports